import React, { useState, useEffect } from "react";
import ImageCard from "../../atoms/ImageCard";
import Button from "../../atoms/Button";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as CloseBtn } from "../../svgs/close.svg";

const ProjectCard = ({
  closeBtn = false,
  actionButton = true,
  _id,
  project: {
    _id: projectId,
    projectName,
    tokenType,
    location: { country, state },
    ogScore = 30,
    cover_image,
    SDG_contribution,
    typeOfCredit,
    categoryDetails: { categoryName },
    subCategoryDetails: { subCategoryName },
    registryDetails: { registryName, registryImage }
  },
  userData: { userId },
  numberOfCredits = "0 Credits",
  no_of_credits_to_sell = "0",
  projectImage = "/images/projectone.png",
  price_per_credit = "0",
  isListed = true,
  credit_transaction = "Fully"
}) => {
  const navigate = useNavigate();
  return (
    <Link to={`/project-details?projectId=${projectId}&userId=${userId}`}>
      <div className="flex flex-row bg-white rounded-2xl h-[8.5rem]">
        <div className="ml-1 my-1 relative">
          <ImageCard
            iconDisplay="flex"
            classnames="w-[18rem] h-full bg-cover"
            userImage={cover_image}
          />
          <div className="absolute bottom-[0px] left-[0px] bg-white rounded-tr-lg">
            {tokenType === "Gold" && (
              <img
                src="images/GoldTokens.png"
                alt="Gold Token"
                style={{ width: "40px", height: "40px" }}
              />
            )}
            {tokenType === "Silver" && (
              <img
                src="images/SilverTokens.png"
                alt="Silver Token"
                style={{ width: "40px", height: "40px" }}
              />
            )}
            {tokenType === "Bronze" && (
              <img
                src="images/BronzeTokens.png"
                alt="Bronze Token"
                style={{ width: "40px", height: "40px" }}
              />
            )}
          </div>
        </div>
        <div className="flex  w-full justify-between ">
          <div className="ml-4 p-2 flex flex-col justify-between">
            <div className="flex flex-row ">
              <h1 className="w-fit text-2xl shrink-0 font-black">
                {projectName}
              </h1>
              <div
                className="w-12 h-12 ml-2 bg-no-repeat"
                style={{
                  backgroundPosition: "top",
                  background: `url(${registryImage})`,
                  backgroundPosition: "center",
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat"
                }}
              ></div>
            </div>
            <h2 className="text-lg h-fit w-fit">{`${state}, ${country}`}</h2>
            <div className="text-sm">
              <h3>
                <span className="font-bold">
                  Listed Credits - {no_of_credits_to_sell} |
                </span>
                <span className="font-medium">
                  {" "}
                  Total Credits - {numberOfCredits} |
                </span>
                <span className=" capitalize">
                  {` ${credit_transaction} `}|
                </span>
                <span className=" capitalize"> {` ${typeOfCredit}`}</span>
              </h3>
            </div>
          </div>
          <div className="pt-2 pr-4 flex flex-col">
            {closeBtn && (
              <CloseBtn
                className="w-4 self-end"
                onClick={() => {
                  navigate(-1);
                }}
              />
            )}
            <div className="text-blue-200 mt-2 text-right">
              <div className="flex justify-end gap-3">
                <h1 className="text-xs text-blue-800 ">{categoryName}</h1>
              </div>
              <h2 className="text-sm font-bold mt-1 text-blue-800">
                OG Score - {ogScore}
              </h2>
              <h3 className="text-xl text-black mt-1 font-medium text-right">
                $ {price_per_credit} per Credits
              </h3>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};
export default ProjectCard;
